import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-sidebar-nav',
  templateUrl: './sidebar-nav.component.html',
  styleUrls: ['./sidebar-nav.component.css'],
})
export class SidebarNavComponent implements OnInit {
  date: Date = new Date();
  userDetails: any = null;
  navItems: {
    label: string;
    link: string;
    icon: string;
    iconhover: string;
  }[] = [];

  constructor(
    private router: Router,
    public authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.userDetails = this.authService.getUserSessionDetails();

    this.navItems = [];
    // this.navItems.push({ label: 'Dashboard', link: '/dashboard/home', icon: 'assets/img/icon1.png', iconhover: 'assets/img/icon1h.png' });

    if (['seller', 'broker'].includes(this.userDetails.role)) {
      if (this.userDetails?.role == 'seller') {
        this.navItems.push({
          label: 'Search Offer Sheet',
          link: '/dashboard/buyer/offer-sheet/search',
          icon: 'assets/img/icon16.png',
          iconhover: 'assets/img/icon16h.png',
        });
        this.navItems.push({
          label: 'Pre Sales',
          link: '/dashboard/seller/my/pre-sale',
          icon: 'assets/img/home.png',
          iconhover: 'assets/img/homeh.png',
        });
        this.navItems.push({
          label: 'Active Offer Sheet',
          link: '/dashboard/seller/offer-sheet/active',
          icon: 'assets/img/icon3.png',
          iconhover: 'assets/img/icon3h.png',
        });
        this.navItems.push({
          label: 'Closed Offer Sheet',
          link: '/dashboard/seller/offer-sheet/closed',
          icon: 'assets/img/icon4.png',
          iconhover: 'assets/img/icon4h.png',
        });
        this.navItems.push({
          label: 'Post Sales',
          link: '/dashboard/seller/my/post-sale',
          icon: 'assets/img/home.png',
          iconhover: 'assets/img/homeh.png',
        });
      } else {
        this.navItems.push({
          label: 'Generate Offer Sheet',
          link: '/dashboard/seller/offer-sheet/generate',
          icon: 'assets/img/icon1.png',
          iconhover: 'assets/img/icon1h.png',
        });
        this.navItems.push({
          label: 'Pre Sales',
          link: '/dashboard/seller/pre-sale',
          icon: 'assets/img/home.png',
          iconhover: 'assets/img/homeh.png',
        });
        // this.navItems.push({ label: 'Dispatched Offer Sheet', link: '/dashboard/seller/offer-sheet/dispatched', icon: 'assets/img/icon2.png', iconhover: 'assets/img/icon2h.png' });
        this.navItems.push({
          label: 'Active Offer Sheet',
          link: '/dashboard/seller/offer-sheet/active',
          icon: 'assets/img/icon3.png',
          iconhover: 'assets/img/icon3h.png',
        });
        this.navItems.push({
          label: 'Closed Offer Sheet',
          link: '/dashboard/seller/offer-sheet/closed',
          icon: 'assets/img/icon4.png',
          iconhover: 'assets/img/icon4h.png',
        });
        this.navItems.push({
          label: 'Post Sales',
          link: '/dashboard/seller/post-sale',
          icon: 'assets/img/home.png',
          iconhover: 'assets/img/homeh.png',
        });

        this.navItems.push({
          label: 'Reports',
          link: '/dashboard/seller/reports/generate',
          icon: 'assets/img/icon5.png',
          iconhover: 'assets/img/icon5h.png',
        });
      }
    } else if (['buyer'].includes(this.userDetails.role)) {
      this.navItems.push({
        label: 'Search Offer Sheet',
        link: '/dashboard/buyer/offer-sheet/search',
        icon: 'assets/img/icon16.png',
        iconhover: 'assets/img/icon16h.png',
      });
      this.navItems.push({
        label: 'Pre-Sales',
        link: '/dashboard/buyer/pre-sale',
        icon: 'assets/img/home.png',
        iconhover: 'assets/img/homeh.png',
      });

      //this.navItems.push({ label: 'View catalogue & Prices', link: '/dashboard/buyer/catalogue', icon: 'assets/img/document.png', iconhover: 'assets/img/document.png' });
      // this.navItems.push({ label: 'Received Offer Sheet', link: '/dashboard/buyer/offer-sheet/received', icon: 'assets/img/icon2.png', iconhover: 'assets/img/icon2h.png' });
      this.navItems.push({
        label: 'Active Offer Sheet',
        link: '/dashboard/buyer/offer-sheet/active',
        icon: 'assets/img/icon3.png',
        iconhover: 'assets/img/icon3h.png',
      });
      this.navItems.push({
        label: 'Closed Offer Sheet',
        link: '/dashboard/buyer/offer-sheet/closed',
        icon: 'assets/img/icon4.png',
        iconhover: 'assets/img/icon4h.png',
      });
      this.navItems.push({
        label: 'Post Sales',
        link: '/dashboard/buyer/post-sale',
        icon: 'assets/img/home.png',
        iconhover: 'assets/img/homeh.png',
      });
      this.navItems.push({
        label: 'Reports',
        link: '/dashboard/buyer/reports/generate',
        icon: 'assets/img/icon5.png',
        iconhover: 'assets/img/icon5h.png',
      });
    }

    /**
     * CHECK THE LAST PROPERTY OF SIDEBAR
     * ==================================
     */
    const sidebarMinimized: any = localStorage.getItem(
      'teainntech-sidebar-minimized',
    );
    if (sidebarMinimized && sidebarMinimized == '1') {
      document
        .getElementById('layoutSidenav')
        ?.classList.add('minimize-active');
    }
  }

  /**
   * SIDEBAR TOGGLE FUNCTIONS
   * ========================
   */
  checkSidebarIsToggled(): boolean {
    const layoutSidenav = document.querySelector('#layoutSidenav');
    if (layoutSidenav) {
      return layoutSidenav.classList.contains('minimize-active');
    }

    return false;
  }

  toggleSidebar() {
    const layoutSidenav = document.getElementById('layoutSidenav');
    if (layoutSidenav) {
      const action: any = layoutSidenav.classList.toggle('minimize-active');

      localStorage.setItem(
        'teainntech-sidebar-minimized',
        action === true ? '1' : '0',
      );
    }
  }
}
